import {useEffect,useState} from 'react'
import { getSplash} from '../services/services'
import {Accardion} from '../components'
import {LinearProgress} from "@mui/material";

const Faq = () => {
    const [dataNeeded,setData] = useState(false)

    const getdata = async ()=>{
        const res = await getSplash()
        if (res && res.data.code == 1) {

            setData(res.data.faq)
        }
    }

    useEffect(() => {
        getdata().then();
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });



    }, []);

    let content
    if (dataNeeded!==false){

        content = dataNeeded.map((d)=>(
            <Accardion key={d.id} a={d.answer} q={d.q} id={d.id}/>
        ))

    } else {
        content =  <div className='column is-12'>
            <LinearProgress variant='indeterminate' color='secondary'  sx={{
                '&.MuiLinearProgress-root':{
                    backgroundColor:'#219ebc'
                }


            }}/>
        </div>
    }



  return(
      <>
          <main style={{minHeight:'60vh'}}>
              <section>

                  <div className='columns navpadstart150 navpadend150 mx-0 is-multiline '>

                      <div className='column is-12 is-relative' >


                          <h1 className='is-size-4-mobile is-size-4-desktop kook has-text-weight-bold mb-6'>
                              سوالات متداول
                          </h1>



                      </div>

                      {content}

                  </div>
              </section>
          </main>


      </>
  )
}
export default Faq;